import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Admin Audit Logs API calls
 */
const auditLogService = {
  /**
   * Get audit logs list with pagination and filters
   * @param {Object} params - Query parameters
   * @returns {Promise<Object>}
   */
  async getAuditLogs(params = {}) {
    try {
      const queryParams = buildQueryParams({
        page: params.page || 1,
        limit: params.limit || 20,
        search: params.search,
        action: params.action,
        targetModel: params.targetModel,
        userId: params.userId,
        startDate: params.startDate,
        endDate: params.endDate,
      });

      const response = await apiClient.get(`${API_ENDPOINTS.ADMIN_AUDIT_LOGS.LIST}?${queryParams}`);
      
      return {
        success: true,
        data: response.data || [],
        pagination: response.pagination,
      };
    } catch (error) {
      throw new Error(handleError(error, 'auditLogService.getAuditLogs'));
    }
  },

  /**
   * Get audit logs stats (total and breakdowns)
   * @returns {Promise<Object>}
   */
  async getAuditLogStats() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ADMIN_AUDIT_LOGS.STATS);
      
      return {
        success: true,
        data: response.data || null,
      };
    } catch (error) {
      throw new Error(handleError(error, 'auditLogService.getAuditLogStats'));
    }
  },
};

export default auditLogService;
